// Quick add without leaving the grid.
//
// Lives in assets/ rather than in snippets/product-card.liquid because Shopify's
// {% javascript %} bundle is built ONLY from the sections named in the page's
// data-sections attribute — a snippet's javascript block is silently dropped.
// Verified: the compiled bundle carried the grid section's JS and none of the
// card's, so the handler never ran and every add did a full page navigation.
//
// Delegated from document, so one load covers every surface that renders a card.
//
// The native form POST remains the no-JS fallback, and is also the recovery path
// if the fetch fails — a shopper is never left with a dead button.
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form.pcard__quickadd');
      if (!form || form.dataset.fallback) return;
      e.preventDefault();

      var btn = form.querySelector('[data-quickadd-btn]');
      var label = form.querySelector('[data-quickadd-label]');
      var idField = form.querySelector('[name="id"]');
      if (!btn || !label || !idField) return;
      if (btn.disabled) return;

      var was = label.textContent;
      btn.disabled = true;
      label.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: idField.value, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (n) {
            n.textContent = cart.item_count;
          });
          form.classList.add('is-added');
          label.textContent = 'Added';
          // Let the drawer confirm with the running total and the meter. The
          // inline label stays: it marks WHICH card was added, which the drawer
          // cannot.
          document.dispatchEvent(new CustomEvent('bmtc:cart-added'));
          setTimeout(function () {
            form.classList.remove('is-added');
            label.textContent = was;
            btn.disabled = false;
          }, 2200);
        })
        .catch(function () {
          // Fall back to the real form rather than stranding the shopper.
          form.dataset.fallback = '1';
          label.textContent = was;
          btn.disabled = false;
          form.submit();
        });
    });
  });
})();
